import { MenuCategory } from "@/types/common";

export const backToSchoolMenuData: MenuCategory[] = [
  {
    title: "NEW & FEATURED",
    titleHref: "/back_to_school",
    items: [
      { name: "Shoes Under $100", href: "/back_to_school-shoes-under-100", translationKey: "shoesUnder100" },
      { name: "Must Have Shoes", href: "/back_to_school-must-have-shoes", translationKey: "mustHaveShoes" },
      { name: "Mini Me Outfits", href: "/back_to_school-mini-me-outfits", translationKey: "miniMeOutfits" },
      { name: "Sportswear", href: "/back_to_school-sportswear", translationKey: "sportswear" },
      { name: "On Trend: Track Pants", href: "/back_to_school-track-pants", translationKey: "onTrendTrackPants" },
    ],
  },
  {
    title: "KIDS",
    titleHref: "/kids-back_to_school",
    items: [
      { name: "Shoes", href: "/kids-back_to_school-shoes", translationKey: "shoes" },
      { name: "Clothing", href: "/kids-back_to_school-clothing", translationKey: "clothing" },
      { name: "Matching Sets", href: "/kids-back_to_school-matching-sets", translationKey: "matchingSets" },
      { name: "Backpacks", href: "/kids-back_to_school-backpacks", translationKey: "backpacks" },
      { name: "Shoes Under $60", href: "/kids-back_to_school-shoes-under-60", translationKey: "shoesUnder60" },
      { name: "Soccer Gear", href: "/kids-back_to_school-soccer", translationKey: "soccerGear" },
      { name: "Basketball Gear", href: "/kids-back_to_school-basketball", translationKey: "basketballGear" },
      { name: "Running Gear", href: "/kids-back_to_school-running", translationKey: "runningGear" },
      { name: "Youth [Age 8-16]", href: "/kids-back_to_school-youth", translationKey: "youthAge8to16" },
      { name: "Child [Age 4-8]", href: "/kids-back_to_school-children", translationKey: "childAge4to8" },
    ],
  },
  {
    title: "MEN",
    titleHref: "/men-back_to_school",
    items: [
      { name: "Shoes", href: "/men-back_to_school-shoes", translationKey: "shoes" },
      { name: "Clothing", href: "/men-back_to_school-clothing", translationKey: "clothing" },
      { name: "Matching Sets", href: "/men-back_to_school-matching-sets", translationKey: "matchingSets" },
      { name: "Bags", href: "/men-back_to_school-bags", translationKey: "bags" },
      { name: "Shoes Under $80", href: "/men-back_to_school-shoes-under-80", translationKey: "shoesUnder80" },
    ],
  },
  {
    title: "WOMEN",
    titleHref: "/women-back_to_school",
    items: [
      { name: "Shoes", href: "/women-back_to_school-shoes", translationKey: "shoes" },
      { name: "Clothing", href: "/women-back_to_school-clothing", translationKey: "clothing" },
      { name: "Matching Sets", href: "/women-back_to_school-matching-sets", translationKey: "matchingSets" },
      { name: "Bags", href: "/women-back_to_school-bags", translationKey: "bags" },
      { name: "Shoes Under $80", href: "/women-back_to_school-shoes-under-80", translationKey: "shoesUnder80" },
    ],
  },
  {
    title: "SCHOOL ESSENTIALS",
    titleHref: "/essentials-back_to_school",
    items: [
      { name: "School Backpacks", href: "/essentials-back_to_school-backpacks", translationKey: "schoolBackpacks" },
      { name: "Lunch Bags", href: "/essentials-back_to_school-lunch-bags", translationKey: "lunchBags" },
      { name: "Water Bottles", href: "/essentials-back_to_school-water-bottles", translationKey: "waterBottles" },
      { name: "Hoodies & Sweatshirts", href: "/essentials-back_to_school-hoodies-sweatshirts", translationKey: "hoodiesSweatshirts" },
      { name: "School Shoes", href: "/essentials-back_to_school-school-shoes", translationKey: "schoolShoes" },
      { name: "Socks", href: "/essentials-back_to_school-socks", translationKey: "socks" },
      { name: "School Uniforms", href: "/essentials-back_to_school-uniforms", translationKey: "schoolUniforms" },
    ],
  },
];
